<template>
  <div id="app">
    <el-container>
      <el-header height="68">
        <div class="logo">
          <img src="./assets/logo.png" alt />
          <div>拉拉买车</div>
        </div>
        <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          active-text-color="#F16622"
          @select="handleSelect"
          :router="router"
          style="width: 750px"
        >
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item index="/rentalCar">租买货车</el-menu-item>
          <el-menu-item index="/laLaPartner">LaLaPartner</el-menu-item>
          <el-menu-item index="/carAftherMarket">汽车后市场</el-menu-item>
        </el-menu>
        <div class="sale">销售热线： <span>36361988</span></div>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <div class="footer" v-show="isShow">
        <div class="footer-content">
          <div class="content-nav">
            <ul>
              <li>
                <p>首页</p>
                <span @click="turnTo('/')">拉拉买车首页</span>
              </li>
              <li>
                <p>关于</p>
                <!-- <span>公司介绍</span> -->
                <span @click="turnTo('/aboutMe')">关于我们</span>
                <span @click="turnTo('/addWe')">加入我们</span>
                <span @click="turnTo('/contactWe')">联系我们</span>
              </li>
              <li>
                <p>条款及协议</p>
                <span @click="turnTo('/privacyPolicy')">隐私条款</span>
                <span @click="turnTo('/userAgreement')">用户协议</span>
              </li>
            </ul>
            <!-- <div class="nav-line">
              <p>车型合作伙伴</p>
              <div>
                <span>品牌logo</span>
                <span>品牌logo</span>
                <span>品牌logo</span>
              </div>
            </div> -->
            <div class="nav-line">
              <p>友情链接</p>
              <div>
                <span @click="goPage('https://www.pcauto.com.cn/')"
                  >太平洋汽车</span
                >
                <span @click="goPage('https://www.dcdapp.com/')">懂车帝</span>
              </div>
            </div>
          </div>

          <div>
            <ul class="content-nav-right">
              <li>
                <p>扫码购车</p>
                <img src="./assets/urcode.png" alt="" />
              </li>
              <li>
                <p>关注我们</p>
                <img src="./assets/wxcode.png" alt="" />
              </li>
            </ul>
            <div style="color: #a3a3a3; font-size: 12px">
              客户服务热线：36361988
            </div>
            <div style="color: #a3a3a3; font-size: 12px">
              服务时间： 周一至周日 9:00-18:00
            </div>
          </div>
        </div>
        <div class="copyright">
          <span>深圳市啦啦配送有限公司</span><span>|</span>
          <span
            >粤ICP备36361988号
            <!-- 增值电信业务经营许可证：粤B22222222222
            营业执照 -->
          </span>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  data () {
    return {
      router: true,
      defaultActive: '',
      isShow: true
    };
  },
  watch: {   //监听路由变化
    $route (to) {
      this.defaultActive = to.path
      // to , from 分别表示从哪跳转到哪，都是一个对象
      // to.path  ( 表示的是要跳转到的路由的地址 eg: /home );
    }
  },
  mounted () {
    // console.log(this.$route.path,'this.$route.path')
    setTimeout(() => {
      this.defaultActive = this.$route.path
    }, 100)
  },
  methods: {
    handleSelect (key) {
      this.isShow = this.defaultActive != key;
    },
    goPage (val) {
      window.open(val);
    },
    turnTo (path) {
      this.$router.push({ path })
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.el-menu-item {
  height: 70px !important;
}
.el-header {
  display: flex;
  // justify-content: space-between;
  align-content: center;
  width: 1080px;
  margin: 0 auto;
  //background-color: #fff;

  .logo {
    width: 280px;
    padding: 6px;
    img {
      width: 56px;
      height: 56px;
      vertical-align: middle;
    }
    div {
      display: inline-block;
      font-size: 24px;
      font-weight: 500;
      color: #2f3439;
      margin-left: 10px;
    }
  }
  .sale {
    width: 273px;
    line-height: 71px;
    font-size: 14px;
    color: #768191;
    span {
      font-size: 16px;
      font-weight: 500;
      color: #2f3439;
    }
  }
}
.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  height: 350px;
  overflow: hidden;
  background-color: #333333;
  .content-nav-right {
    // flex: 1;
    display: inline-block;
    justify-content: space-around;
    li {
      display: inline-block;
      // flex-direction: column;
      // padding: 0 20px;
      margin-right: 65px;
      //justify-content: center;
      // align-items: flex-start;
      p {
        font-size: 14px;
        font-weight: 500;
        color: #e2e2e2;
        line-height: 18px;
        padding-top: 8px;
      }
      span {
        font-size: 12px;
        color: #a3a3a3;
        line-height: 18px;
        padding-top: 8px;
      }
    }
  }
  &-content {
    width: 1080px;
    margin: 0 auto;
    padding-top: 48px;
    display: flex;
    justify-content: space-between;
    .content-nav {
      flex: 1;
      ul {
        display: flex;
        justify-content: space-around;
      }
      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        margin-right: 45px;
        //justify-content: center;
        align-items: flex-start;
        p {
          font-size: 14px;
          font-weight: 500;
          color: #e2e2e2;
          line-height: 18px;
          padding-top: 8px;
          cursor: pointer;
        }
        span {
          font-size: 12px;
          color: #a3a3a3;
          line-height: 18px;
          padding-top: 8px;
          cursor: pointer;
        }
      }
    }
    > div {
      flex: 1;
      border-left: 1px solid #434343;
      padding-left: 80px;
    }
    img {
      width: 118px;
      height: 118px;
      padding: 10px 0;
    }
  }
  .copyright {
    height: 30px;
    text-align: center;
    margin-top: 30px;
    // background: #125688;
    span {
      font-size: 12px;
      font-weight: 400;
      color: #a3a3a3;
      line-height: 18px;
    }
  }
}
.nav-line {
  padding: 0 20px;
  margin-bottom: 20px;
  p {
    font-size: 14px;
    font-weight: 500;
    color: #e2e2e2;
    line-height: 18px;
    padding-top: 8px;
  }
  span {
    font-size: 12px;
    color: #a3a3a3;
    line-height: 18px;
    padding-top: 8px;
    margin-right: 20px;
    cursor: pointer;
  }
}
.el-menu.el-menu--horizontal {
  border: 0 !important;
}
</style>
